import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ContainerDefault from '../../components/ContainerDefault';
import { ErrorMessage, Loading } from '../../components/UtilComponent';
import * as Constants from '../../utils/constants';
import * as pesagemAction from '../../services/pesagem/Action'
import TablePesagem from './components/TablePesagem'
import Swal from 'sweetalert2';



class Index extends Component {

    constructor(props) {
        super(props)
        this.handlePrintTermica = this.handlePrintTermica.bind(this);
        this.handleClickDelete = this.handleClickDelete.bind(this);
        this.state = {
            checked: false
        };
    }
    handleClickTodos = () => {
        this.setState({ checked: !this.state.checked });
    
        this.props.action.getPesagensFullAction(this.state.checked);
    }

    componentDidMount() {
        this.props.action.getPesagensFullAction(!this.state.checked);
    }
    handleClick = (event, id) => {
        console.log(id);
    };

    handlePrintTermica(id) {
        Swal.fire({
            title: 'Realizar Impressão de nota não fiscal?',
            text: 'Informe a quantidade de cópias para impressão!',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, realizar impressão!',
            icon: "question",
            input: 'select',
            inputOptions: {
                '1': '1',
                '2': '2',
                '3': '3',
                '4': '4',
                '5': '5',
            },
            inputValue: '1',
            preConfirm: async (value) => {
                try {
                    if (!value) throw { 'detail': 'Informe pelo menos 1 cópia!' };
                    await this.props.action.setImpressaoTermica({ 'id': id, 'copia': value });
                    return 'ok'
                } catch (err) {
                    if (err) {
                        Swal.fire({
                            text: `${err['detail'] ? err['detail'] : ''}`,
                            icon: "error",
                        });
                    } else {
                        Swal.stopLoading();
                        Swal.close();
                    }

                    throw err;
                }
            },
            allowOutsideClick: () => !Swal.isLoading()

        }).then((result) => {
            if (result.value) {
                Swal.fire({
                    text: "Impressão realizada com sucesso!",
                    icon: "success",
                });
            } else {
                Swal.fire({
                    text: "Operação cancelada!",
                    icon: "info",
                });
            }
        }).catch(err => {
            if (err) {
                Swal.fire({
                    text: `Operação cancelada! ${err['detail'] ? err['detail'] : ''}`,
                    icon: "error",
                });
            } else {
                Swal.stopLoading();
                Swal.close();
            }
        });
    }
    handleClickDelete = (id) => {
        Swal.fire({
            title: "Excluir item?",
            text: `Você realmente deseja excluir a pesagem com código ${id} ? `,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Sim, excluir pesagem!',
            preConfirm: async (willDelete) => {
                try {
                    await this.props.action.desativarPesagemByIdAction(id);
                    await this.props.action.getPesagensFullAction();
                    return 'ok'
                } catch (err) {
                    throw err;
                }
            },
            dangerMode: true,
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if (result.value) {
                Swal.fire({
                    text: "Pesagem Excluída com sucesso!",
                    icon: "success",
                });
            } else {
                Swal.fire({
                    text: "Operação cancelada!",
                    icon: "info",
                });
            }
        }).catch(err => {
            if (err) {
                Swal.fire({
                    text: `Operação cancelada! ${err['detail'] ? err['detail'] : ''}`,
                    icon: "error",
                });
            } else {
                Swal.stopLoading();
                Swal.close();
            }
        });
    };

    retornarDadosTela() {
        const { pesagemObject, messages, isLoading } = this.props;

        if (Object.entries(pesagemObject).length === 0 && pesagemObject.constructor === Object && isLoading)
            return <Loading title={Constants.DESCRICAO_PESAGENS} />

        return (
            <ContainerDefault
                title={Constants.DESCRICAO_PESAGENS}
                url={Constants.ROUTE_URL_PESAGEM}
                messages={messages}
                button={Constants.DESCRICAO_NOVA_PESAGEM}
                container={<TablePesagem handlePrintTermica={this.handlePrintTermica} handleClickDelete={this.handleClickDelete} pesagemObject={pesagemObject ? pesagemObject : []}
                    edit_url={Constants.ROUTE_URL_PESAGEM} 
                    handleClickTodos={this.handleClickTodos}
                    checked={this.state.checked}/>}
            />);

    }
    render() {
        return (
            this.retornarDadosTela()
        )
    }
}

const mapStateToProps = state => ({
    pesagemObject: state.pesagemReducer.pesagemObject,
    messages: state.messageResponseReducer.messages,
    isLoading: state.apiReducer.isLoading
});

const mapDispatchToProps = dispatch => ({
    action: bindActionCreators(pesagemAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
